<template>
  <!-- 主路由内容 -->
  <div v-if="isMainRoute" class="company-main-layout">
    <!-- 使用Banner组件 -->
    <Banner :banner-list="bannerList" :accordion-items="accordionItems" />
  </div>
  
  <!-- 子路由内容 -->
  <div v-else class="layout-container">
    <div class="sidebar">
      <el-menu
        :router="true"
        :default-active="route.path"
      >
        <el-menu-item index="/news/company">
          {{ t('pages.news.company.news.title') }}
        </el-menu-item>
        <el-menu-item index="/news/downloads">
          {{ t('pages.news.downloads.title') }}
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { computed, ref } from 'vue';
import Banner from '@/components/Home/Banner.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

// 判断是否是主路由
const isMainRoute = computed(() => {
  return route.path === '/news' || route.path === '/news/';
});

// 导航到子路由
const navigateTo = (path: string) => {
  router.push(path);
};

// 配置Banner组件的banner列表
const bannerList = ref([
  {
    image: '/images/homebanner/Banner01.jpg',
    title: '公司动态',
    titleAnimation: 'fade-in-down',
    descAnimation: 'fade-in-up'
  },
 
]);

// 配置AccordionSection组件的内容项
const accordionItems = ref([
  {
    title: 'pages.news.company.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/news/company'
  },
  {
    title: 'pages.news.downloads.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/news/downloads'
  },
  
]);

const companySections = [
 
  {
    title: 'pages.news.company.title',

    path: '/news/company'
  }, {title:'pages.news.downloads.title',
    
    path: '/news/downloads'
  },
];
</script>

<style scoped lang="scss">
// 子路由布局样式
.layout-container {
  display: flex;
  padding: 100px 40px 40px;
  max-width: 1400px;
  margin: 0 auto;
  gap: 40px;

  .sidebar {
    width: 280px;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    min-width: 0;
  }
}

// 主路由布局样式
.company-main-layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .layout-container {
    flex-direction: column;
    padding: 80px 20px 20px;
    gap: 20px;
    align-items: center;

    .sidebar {
      display: none;
    }

    .content {
      width: 100%;
      max-width: 800px;
      text-align: center;
    }
  }
}
</style> 